import { Plant } from '../types/plant';

/**
 * Formats a plant's scientific name according to botanical naming conventions
 * @param plant The plant object containing variety information
 * @returns Formatted scientific name string or null if no variety info
 */
export function formatScientificName(plant: Plant): string | null {
  if (!plant.variety) return null;

  const { species, subspecies, cultivarName } = plant.variety;
  let name = `${species.genus.name} ${species.name}`;

  if (subspecies) {
    name += ` subsp. ${subspecies}`;
  }

  if (cultivarName) {
    name += ` '${cultivarName}'`;
  }

  return name;
}
